import withLink from './withLink';

const NavLink = withLink('li');

export default NavLink;
